import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

interface SuccessState {
  invitationCode?: string;
}

const BetaInvitationSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as SuccessState;

  const [invitationCode] = useState(state?.invitationCode || '');

  useEffect(() => {
    // If no state, redirect back to beta invitation page
    if (!state || !state.invitationCode) {
      navigate('/beta-invitation', { replace: true });
    }
  }, [state, navigate]);

  if (!invitationCode) {
    return null;
  }

  return (
    <div className="main-wrapper beta-invite-success-page">
      {/* Hero Banner Section */}
      <div className="section-hero-banar is-beta-invite">
        <div className="padding-global">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="hero-banner-component">
                <div className="hero-banner-content-wrapper">
                  <h2 className="heading-style-h2">
                    {t('betaInvitationSuccess.title')}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="section-price-area is-beta-invite">
        <div className="padding-global">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="price-area-component">
                {/* Invitation Code Display */}
                <div className="price-area-top-content-wrapper">
                  {invitationCode && (
                    <div className="support-card-item boder-line-color-green" style={{
                      margin: '40px auto',
                      maxWidth: '500px',
                      boxShadow: '0 8px 24px rgba(142, 194, 19, 0.15)'
                    }}>
                      <div className="support-area-details">
                        <div className="text-size-regular" style={{ color: '#666', marginBottom: '8px' }}>
                          {t('betaInvitationSuccess.codeLabel')}
                        </div>
                        <h3 className="heading-style-h3" style={{
                          color: '#8ec213',
                          letterSpacing: '6px',
                          fontWeight: 'bold',
                          fontSize: '2.5rem',
                          margin: '16px 0'
                        }}>
                          {invitationCode}
                        </h3>
                        <p className="text-size-small" style={{ color: '#888', fontStyle: 'italic' }}>
                          {t('betaInvitationSuccess.saveCodeHint')}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                <div className="padding-bottom padding-xxlarge"></div>

                {/* Next Steps Section */}
                <div className="contact-us-form-block">
                  <div className="contact-us-heading-content">
                    <div className="heading-wrapper">
                      <h3 className="heading-style-h3">{t('betaInvitationSuccess.nextSteps.title')}</h3>
                      <div className="line-color-light-blue"></div>
                    </div>
                  </div>
                  <div className="padding-bottom padding-medium"></div>

                  <div style={{
                    background: 'white',
                    borderRadius: '8px',
                    padding: '25px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }}>
                    <ol style={{
                      paddingLeft: '20px',
                      margin: 0,
                      lineHeight: '2'
                    }}>
                      <li>{t('betaInvitationSuccess.nextSteps.step1')}</li>
                      <li>{t('betaInvitationSuccess.nextSteps.step2')}</li>
                      <li>{t('betaInvitationSuccess.nextSteps.step3')}</li>
                    </ol>
                  </div>

                  <div className="padding-bottom padding-medium"></div>

                  {/* Action Buttons */}
                  <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '30px', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => navigate('/')}
                      className="button w-button"
                    >
                      {t('betaInvitationSuccess.backToHome')}
                    </button>
                    <button
                      onClick={() => {
                        // Copy invitation code to clipboard
                        navigator.clipboard.writeText(invitationCode);
                        alert(t('betaInvitationSuccess.codeCopied'));
                      }}
                      className="button w-button"
                      style={{
                        background: 'white',
                        color: '#8ec213',
                        border: '2px solid #8ec213'
                      }}
                    >
                      {t('betaInvitationSuccess.copyCode')}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetaInvitationSuccessPage;
